/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHexagons = createReactComponent("hexagons", "IconHexagons", [
  ["path", { d: "M4 18v-5l4 -2l4 2v5l-4 2z", key: "svg-0" }],
  ["path", { d: "M8 11v-5l4 -2l4 2v5", key: "svg-1" }],
  ["path", { d: "M12 13l4 -2l4 2v5l-4 2l-4 -2", key: "svg-2" }]
]);

export { IconHexagons as default };
//# sourceMappingURL=IconHexagons.js.map
